<flex-column adEl [gap]="0" style="height: 100vh">
  <mat-toolbar adEl="appToolbar" color="primary" style="padding-left: 8px">
    <flex-row adEl="headerBar" [gap]="0" [alignCenter]="true" grow>
      @if ((authService.currentUser | async) && visibleSidenavPages.length > 0)
      {
      <button
        adEl
        mat-icon-button
        (click)="toggleSidenav($event)"
        aria-label="Toggle navigation"
      >
        <mat-icon adEl>menu</mat-icon>
      </button>
      }
      <flex-row
        adEl="brandLockup"
        [gap]="8"
        [alignCenter]="true"
        [fitContent]="true"
      >
        <a adEl routerLink="/" style="color: inherit; text-decoration: none"
          >OptiMatch</a
        >
      </flex-row>
      <span adEl="headerSpacer" grow style="flex: 1 1 auto"></span>
      <flex-row
        adEl="headerActions"
        [gap]="8"
        [alignCenter]="true"
        [fitContent]="true"
      >
        @if (authService.currentUser | async) {
        <avatar adEl="userAvatar"></avatar>
        }
      </flex-row>
    </flex-row>
  </mat-toolbar>
  <mat-sidenav-container adEl="sidenavContainer" grow>
    <mat-sidenav
      adEl="sidenavRail"
      mode="over"
      [opened]="sidenavOpen"
      (closedStart)="sidenavOpen = false"
      autoFocus="false"
      style="width: fit-content; margin: 8px 0; padding: 0 8px"
    >
      <mat-nav-list adEl>
        @for (page of visibleSidenavPages; track $index) {
        <a
          adEl
          mat-list-item
          [routerLink]="page.path"
          routerLinkActive="active"
          (click)="sidenavOpen = false"
        >
          <mat-icon adEl matListItemIcon>{{page.sidenavIcon}}</mat-icon>
          <span adEl>{{page.displayName}}</span>
        </a>
        }
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content adEl="sidenavContent">
      <router-outlet adEl="contentOutlet"></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <mat-toolbar
    adEl="appFooter"
    color="primary"
    style="font-size: 12px; min-height: 32px; height: 32px"
    >Version {{packageService.version}}</mat-toolbar
  >
</flex-column>
